export const errorStatusMsgEN = {
    401: "Username already exists",
    402: "Account creation failed",
    403: "Body missing key",
    404: "Username does not exist",
    405: "Wrong password",
    406: "Error creating access token",
    407: "Error creating refresh token",
    408: "Access token not found",
    409: "No refresh token found",
    410: "Invalid Access Token",
    411: "Invalid refresh token",
    412: "User not found",
    413: "Access token expired",
    414: "Refresh token expired",
    415: "Error updating user information",
    416: "Error updating password",
    417: "Error updating user score",
    418: "Error sending mail",
    419: "gmail not found",
    420: "Error resetting password",
    421: "The gmail account is already in use",
    422: "Error retrieving rating list",
    423: "This name is already in use",
    424: "Param is missing a key",
    425: "Error retrieving mail token"
};